import React from "react";
import Battery20Icon from "@material-ui/icons/Battery20";
import Battery90Icon from "@material-ui/icons/Battery90";
import BatteryFullIcon from "@material-ui/icons/BatteryFull";
import { Color } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { NationalQualification } from "@bonliva-crm/shared";

type NationalQualityStatusIconProps = {
  qualification?: NationalQualification;
};

const iconMap: Record<
  NationalQualification,
  { icon: React.ReactElement; title: string }
> = {
  [NationalQualification.Expired]: {
    icon: <Battery20Icon htmlColor={Color.Error} />,
    title: locale.IsQualifiedAndExpired
  },
  [NationalQualification.Unqualified]: {
    icon: <Battery20Icon htmlColor={Color.Error} />,
    title: locale.IsUnqualified
  },
  [NationalQualification.PresentationReady]: {
    icon: <Battery90Icon htmlColor={Color.Yellow} />,
    title: locale.PresentationReady
  },
  [NationalQualification.Qualified]: {
    icon: <BatteryFullIcon htmlColor={Color.CheckGreen} />,
    title: locale.IsQualified
  }
};

export function NationalQualityStatusIcon({
  qualification
}: NationalQualityStatusIconProps) {
  const iconData = iconMap[qualification];

  return iconData?.icon;
}
